// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select{border:3px solid #d4d4d4;background-color:#fff;cursor:pointer;font-size:18px;font-family:Quicksand,sans-serif;width:100%;vertical-align:top;border-radius:10px}.select.small{font-size:14px;line-height:12px;padding:6px 15px}.select.small svg{width:14px;height:14px}.select svg{fill:#666;width:18px;height:18px;margin-left:10px;vertical-align:top}", ""]);
// Exports
module.exports = exports;
